import { atom } from 'jotai';

export type EmailTag = { type: 'email'; email: string };
export type UserTag = { type: 'user'; displayName: string; user: string };
export type TeamTag = { type: 'team'; title: string; team: string; organization: string };

export type PermissionTag = EmailTag | UserTag | TeamTag;
/**
 * State storing the tags being typed in the input.
 */
export const inviteMembersInputAtom = atom<PermissionTag[]>([]);

/**
 * Selector to know if the input is empty.
 */
export const inviteMembersInputIsEmptySelector = atom(
    (get) => get(inviteMembersInputAtom).length === 0
);
